<script>
import options from './NewLoanCalculatorResult.options'
export default options
</script>

<template>
    <article class="nyk-new-loan-calculator-result" :class="{ 'nyk-new-loan-calculator-result--compare': tables.length > 1 }">
        <NewLoanCalculatorResultDesktop
            :labels="labels"
            :infoBox="infoBox"
            :summaries="summaries"
            :tables="tables"
            :sendCalculation="sendCalculation"
            :showSendCalculation="showSendCalculation"
            :getLoanTypesForSummary="getLoanTypesForSummary"
            :switchLoanType="switchLoanType"
            :switchLoanTypeWithRedirect="switchLoanTypeWithRedirect"
            :openSendCalculationsModal="openSendCalculationsModal"
            :openCompareLoanModal="openCompareLoanModal"
            :adjustLoan="adjustLoan"
            :adjustLoanWithRedirect="adjustLoanWithRedirect"
            :quitCompareMode="quitCompareMode"
            :closeSendCalculationModal="closeSendCalculationModal"
            :links="links" />

        <NewLoanCalculatorResultMobile
            :labels="labels"
            :infoBox="infoBox"
            :summaries="summaries"
            :tables="tables"
            :sendCalculation="sendCalculation"
            :showSendCalculation="showSendCalculation"
            :getLoanTypesForSummary="getLoanTypesForSummary"
            :switchLoanType="switchLoanType"
            :switchLoanTypeWithRedirect="switchLoanTypeWithRedirect"
            :openSendCalculationsModal="openSendCalculationsModal"
            :openCompareLoanModal="openCompareLoanModal"
            :adjustLoan="adjustLoan"
            :adjustLoanWithRedirect="adjustLoanWithRedirect"
            :quitCompareMode="quitCompareMode"
            :closeSendCalculationModal="closeSendCalculationModal"
            :links="links" />
    </article>

    <Loader v-if="isLoading && !modalOpen"></Loader>

    <Modal 
      :open="modalOpen" 
      :isLoading="isLoading && modalOpen"
      @close="closeModal"
      :title="modalTitle"
      :sub-title="modalSubTitle"
      size="large"
      theme="seamless"
    >
      <template #body>
        <AdjustLoanContent v-if="showAdjustLoanModal" v-bind="adjustLoanProps" />
        <SwitchLoanTypeContent v-if="showSwitchLoanTypeModal" v-bind="switchLoanTypeProps" />
      </template>
    </Modal>
</template>
